import React, { useEffect } from 'react';
import { LoggerModule } from '@vlinder-web/logger-module-react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let appealApplicationMachine: any;

const MODULE_NAME = 'machines.appealApplication';
const log: any = LoggerModule?.getInstance();

export const useSMAppealApplication = (_context: any) => {
  console.log('qqqmachineentered');
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  appealApplicationMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(appealApplicationMachine);

  return {
    appealApplicationMachine,
    appealApplicationState: state,
    appealApplicationSend: send,
  };
};
